import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { transparentize } from '../../../../helpers';

export const OptionSwitchOptionStyles = {
  optionSwitch: css`
    width: 100%;
    height: 100%;
    background: white;
    border: 1px solid ${theme.colors.neutral40};
    border-radius: 0;
    color: ${theme.colors.neutral50};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${theme.fontSize(14)};
    transition: color 250ms ease-out, border-color 250ms ease-out, background 200ms ease-out;

    &:focus {
      box-shadow: 0 0 0 4px ${transparentize(0.75, theme.colors.primary50)};
      font-weight: ${theme.font.weight.bold};
      outline: none;
      z-index: ${theme.zIndex.low};
    }

    &:not(:last-of-type) {
      border-right: 0;
    }

    &:first-of-type {
      border-radius: ${theme.borderRadius.small} 0 0 ${theme.borderRadius.small};
    }

    &:last-of-type {
      border-radius: 0 ${theme.borderRadius.small} ${theme.borderRadius.small} 0;
    }

    &[aria-checked='true'] {
      border: 2px solid ${theme.colors.primary50};
      color: ${theme.colors.primary50};
      font-weight: ${theme.font.weight.bold};
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  `,
};
